import styled from "@emotion/styled/macro"
import { theme, device } from "../Theme"
import locationIcon from "./images/location.png"

const ServiceAreasContainer = styled.section`
  position: relative;
  padding: 32px 0 44px;

  .service-areas-bg {
    position: absolute;
  }

  @media ${device.lg} {
    padding: 84px 0 72px;
  }

  .accordion-content {
    display: block;
    margin-top: 40px;

    .accordion__panel {
      padding: 0 0 14px;
    }

    @media ${device.lg} {
      display: none;
    }
  }
`

const ServiceAreasBackground = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;

  & > * {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .background-desktop {
    display: none;

    @media ${device.lg} {
      display: block;
    }
  }

  .background-mobile {
    display: block;

    @media ${device.lg} {
      display: none;
    }
  }
`

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .request-btn {
    margin-top: 0;
  }

  @media ${device.lg} {
    flex-direction: row;
    align-items: flex-start;

    .request-btn {
      margin-top: 16px;
    }
  }
`

const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${device.lg} {
    align-items: flex-start;
  }
`

const Header = styled.p`
  font-family: ${theme.fonts.main};
  font-size: 36px;
  font-weight: 800;
  line-height: 60px;
  letter-spacing: -1px;
  text-align: center;
  color: #010101;
  margin-bottom: 14px;

  @media ${device.lg} {
    font-size: 66px;
    line-height: 80px;
    margin-bottom: 24px;
    text-align: left;
  }
`

const Arrow = styled.div`
  min-height: 2px;
  margin-bottom: 36px;
  height: 2px;
  width: 209px;
  background: ${theme.colors.dark};
  position: relative;

  @media ${device.lg} {
    width: 414px;
  }

  &:before {
    content: " ";
    width: 14px;
    height: 14px;
    min-height: 14px;
    border: 2px solid ${theme.colors.dark};
    background: transparent;
    position: absolute;
    top: -8px;
    left: -18px;
  }

  &:after {
    content: " ";
    width: 10px;
    height: 10px;
    background: ${theme.colors.primary};
    position: absolute;
    top: -4px;
    left: -10px;
  }
`

const List = styled.div`
  display: none;
  height: 450px;

  @media ${device.lg} {
    display: flex;
  }
`

const AreasList = styled.div`
  display: flex;
  flex-direction: column;
  width: 380px;

  @media ${device.lg} {
    margin-right: 86px;
  }
`

const LocationsList = styled.div`
  width: 100%;
  ul {
    display: grid;
    grid-template-columns: 1fr 1fr;
    max-height: 400px;
    overflow: auto;
    list-style: none;

    &::-webkit-scrollbar {
      width: 8px;
      overflow: visible;
      margin-right: 32px;
      right: 32px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 4px;
      background: #e3222333;
      margin-right: 32px;
      right: 32px;
    }
    &::-webkit-scrollbar-thumb {
      background: ${theme.colors.primary};
      border-radius: 4px;
      margin-bottom: 4px;
      margin-right: 32px;
      right: 32px;
    }
    @media ${device.lg} {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      align-content: flex-start;
      height: 100%;
      max-height: none;

      &::-webkit-scrollbar {
        height: 8px;
        overflow: visible;
      }
      &::-webkit-scrollbar-track {
        border-radius: 4px;
        background: #e3222333;
      }
      &::-webkit-scrollbar-thumb {
        background: ${theme.colors.primary};
        border-radius: 4px;
        margin-bottom: 4px;
        cursor: pointer;
      }
    }
  }
  ul li {
    width: fit-content;
    position: relative;
    font-size: 17px;
    line-height: 41px;
    letter-spacing: 0px;
    padding-left: 2rem;
    @media ${device.lg} {
      margin: 0.3rem 5rem 0.3rem 0 !important;
    }
  }
  ul li a {
    font-size: 17px;
    line-height: 41px;
    letter-spacing: 0px;
    color: ${theme.colors.primary};
  }

  ul li:before {
    content: url(${locationIcon});
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(0, -50%);
  }
`

const AreaContainer = styled.div`
  margin: 10px 0;
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.0705882);
  background: ${props =>
    props.active ? theme.colors.primary : theme.colors.light};
  padding: 0 19px;
  display: flex;
  align-items: center;
  height: 53px;
  cursor: pointer;
  position: relative;

  &:hover {
    background: ${theme.colors.primary};

    .pivot svg path {
      fill: ${theme.colors.light} !important;
    }

    & > p {
      color: ${theme.colors.light};
    }
  }

  .pivot svg {
    width: 100%;

    path {
      fill: ${props =>
        props.active ? theme.colors.light : theme.colors.primary};
    }
  }

  @media ${device.lg} {
    margin: 15px 0;
    height: 77px;
    padding: 0 30px;
  }

  &:before {
    content: " ";
    position: absolute;
    bottom: -8px;
    left: 0;
    right: 0;
    height: 8px;
    background: ${theme.colors.gray};
  }

  ${props =>
    props.active &&
    `
    @media ${device.lg} {
      &:after {
        content: " ";
        position: absolute;
        width: 16px;
        height: 32px;
        right: -12px;
        top: 50%;
        transform: translate(0, -50%);
        background: ${theme.colors.primary};
        clip-path: polygon(0 0, 100% 50%, 0 100%);
      }
    }
  `}
`

const ImageWrapper = styled.div`
  overflow: hidden;

  ${props =>
    props.size === "medium" &&
    `
    width: 18px;
    height: 24px;

    & svg {
      width: 18px;
      height: 24px;
      object-fit: cover;
    }

    @media ${device.lg} {
      width: 24px;
      height: 28px;

      & svg {
        width: 24px;
        height: 28px;
        object-fit: cover;
      }
    }
  `}

  ${props =>
    props.size === "small" &&
    `
    width: 10px;
    height: 13px;
    
    & svg {
      width: 10px;
      height: 13px;
      object-fit: cover;
    }

    @media ${device.lg} {
      width: 13px;
      height: 17px;

      & svg {
        width: 13px;
        height: 17px;
          object-fit: cover;
        }
      }
  `}
`

const AreaLabel = styled.p`
  font-family: ${theme.fonts.main};
  font-size: 22px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: -0.41px;
  text-align: left;
  margin-left: 13px;
  margin-bottom: 0;
  color: ${props => (props.active ? theme.colors.light : "#010101")};

  @media ${device.lg} {
    font-size: 27px;
    font-weight: 600;
    line-height: 26px;
    margin-left: 20px;
  }
`

const LocationWrapper = styled.div`
  height: 40px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid
    ${props => (props.active ? theme.colors.primary : "#c9c9c9")};
  cursor: pointer;
  box-sizing: border-box;

  &:nth-of-type(odd) {
    margin: 0 21px 0 0;
  }

  &:nth-of-type(even) {
    margin: 0 0 0 21px;
  }

  &:hover {
    border-bottom: 1px solid ${theme.colors.primary};

    & > p {
      color: ${theme.colors.primary};
    }
  }

  @media ${device.lg} {
    width: 173px;
    height: 55px;
    padding: 0 12px;

    &:nth-of-type(odd) {
      margin: 0 40px;
    }

    &:nth-of-type(even) {
      margin: 0 40px;
    }
  }

  @media ${device.xl} {
    width: 235px;
  }
`

const LocationLabel = styled.p`
  font-family: ${theme.fonts.main};
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.44999998807907104px;
  text-align: left;
  color: ${props => (props.active ? theme.colors.primary : "#010101")};
  margin-left: 13px;
  margin-bottom: 0;

  @media ${device.lg} {
    font-size: 18px;
    line-height: 20px;
    margin-left: 16px;
  }
`

const LocationIcon = styled.div`
  position: absolute;
  top: 376px;
  right: 293px;
  display: none;
  z-index: -1;

  @media ${device.lg} {
    display: block;
  }
`

export {
  ServiceAreasContainer,
  ServiceAreasBackground,
  HeaderSection,
  HeaderLeft,
  Header,
  Arrow,
  List,
  AreasList,
  LocationsList,
  AreaContainer,
  ImageWrapper,
  AreaLabel,
  LocationWrapper,
  LocationLabel,
  LocationIcon,
}
